export class RoomMeasurerModel {

    public idRoomMeasurer: number;

    public idRoom: number;

    public idMeasurer: number;

    public name: string;
}